import React, { useState } from "react";
import "./TermsSection.css";

export default function TermsSection() {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="terms-fixed-bar"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pointerEvents: 'none', // allow only the bar and dropdown to be interactive
      }}
    >
      {open && (
        <div
          className="terms-dropdown-content"
          style={{
            background: '#fff',
            boxShadow: '0 2px 16px rgba(0,0,0,0.12)',
            borderRadius: '12px 12px 0 0',
            maxWidth: 420,
            width: '90vw',
            marginBottom: 0,
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: 16,
            fontSize: '0.85rem',
            color: '#222',
            pointerEvents: 'auto',
            maxHeight: '40vh',
            overflowY: 'auto',
            transition: 'max-height 0.4s',
          }}
        >
          <div className="terms-meta" style={{ fontSize: '0.8em', color: '#888', marginBottom: 8 }}>Effective Date: July 7, 2025<br/>Last Updated: July 7, 2025</div>
          <div className="terms-content">
            <p>These Terms and Conditions (“Terms”) govern your access to and use of the Viral Agency Method course and related services offered by Tilted Needle (“we,” “us” or “our”). By purchasing or accessing the course, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you must not access or use the course.</p>
            <h3>1. Definitions</h3>
            <ul>
              <li><b>“Course”</b> means the Viral Agency Method video training program, including all modules, downloads, worksheets, and related digital materials.</li>
              <li><b>“User,” “you” or “your”</b> means the individual or entity purchasing or accessing the Course.</li>
              <li><b>“Content”</b> means all text, images, video, audio, graphics, code, and other materials provided as part of the Course.</li>
              <li><b>“Access Credentials”</b> means your username, password, or any other credentials issued to you to access the Course.</li>
            </ul>
            <h3>2. License & Access Grant</h3>
            <ul>
              <li><b>Limited License.</b> Subject to your compliance with these Terms and payment of all fees, we grant you a non-exclusive, non-transferable, revocable license to access and view the Course for your personal or internal business use only.</li>
              <li><b>Restrictions.</b> You may not:
                <ul>
                  <li>Share, sell, sublicense, distribute, or otherwise make available the Content or your Access Credentials to any third party;</li>
                  <li>Copy, modify, reproduce, publicly display, or create derivative works based on the Content (except as expressly permitted by us);</li>
                  <li>Reverse-engineer, decompile, or disassemble any part of the Course platform or materials.</li>
                </ul>
              </li>
              <li><b>Ownership.</b> All intellectual property rights in the Course and Content remain our sole and exclusive property.</li>
            </ul>
            <h3>3. Payments, Fees & Refund Policy</h3>
            <ul>
              <li><b>Course Fee.</b> The one-time or subscription fee for the Course is as displayed at checkout and payable in GBP (£).</li>
              <li><b>Payment Methods.</b> We accept major credit/debit cards and other payment methods as indicated during checkout.</li>
              <li><b>Taxes.</b> You are responsible for any taxes applicable in your jurisdiction.</li>
              <li><b>Refunds.</b>
                <ul>
                  <li><b>Eligibility Requirement.</b> You may request a full refund only after you have published at least <b>90</b> videos on social platforms, each demonstrating implementation of all seven steps taught in the Course.</li>
                  <li><b>Proof of Implementation.</b> To request a refund, you must submit:
                    <ul>
                      <li>URLs to all <b>90</b> videos; and</li>
                      <li>A written report showing exactly how each of the seven steps was applied in each video.</li>
                    </ul>
                  </li>
                  <li><b>Submission & Review.</b> Email your proof package to <a href="mailto:support@viralagencymethod.com">support@viralagencymethod.com</a>. We will review your submission and notify you of approval or denial within <b>14</b> days.</li>
                  <li><b>Limits.</b> If your submission does not meet these criteria, the refund request will be denied. All other fees are non-refundable.</li>
                </ul>
              </li>
            </ul>
            <h3>4. User Conduct & Account Security</h3>
            <ul>
              <li><b>Accurate Information.</b> You agree to provide accurate and complete registration and billing information, and to keep it up to date.</li>
              <li><b>Account Security.</b> You are responsible for maintaining the confidentiality of your Access Credentials and for all activities under your account. Notify us immediately of any unauthorized use.</li>
              <li><b>Prohibited Conduct.</b> You shall not use the Course or our platform to:
                <ul>
                  <li>Upload or transmit unlawful, threatening, defamatory, obscene, or otherwise objectionable content;</li>
                  <li>Violate any applicable law or regulation;</li>
                  <li>Infringe the rights of any third party;</li>
                  <li>Interfere with or disrupt the integrity of our platform or services.</li>
                </ul>
              </li>
            </ul>
            <h3>5. Disclaimers & No Guarantee of Results</h3>
            <ul>
              <li><b>As-Is Basis.</b> The Course and Content are provided “as is” and “as available.” We expressly disclaim all warranties, whether express or implied, including merchantability, fitness for a particular purpose, and non-infringement.</li>
              <li><b>No Earnings or View Guarantees.</b> While we share our proven 7-step viral framework and best practices, we do not guarantee specific results such as revenue, view counts, or audience growth. Your success depends on many factors outside our control.</li>
            </ul>
            <h3>6. Limitation of Liability</h3>
            <p>To the fullest extent permitted by law, Tilted Needle's total liability arising out of or related to these Terms, the Course, or your use thereof, shall not exceed the total fees paid by you for the Course. We shall not be liable for any indirect, incidental, consequential, punitive, or special damages.</p>
            <h3>7. Indemnification</h3>
            <p>You agree to indemnify, defend, and hold harmless Tilted Needle and its officers, directors, employees, agents, and affiliates from any claims, damages, losses, liabilities, costs, or expenses arising out of:</p>
            <ul>
              <li>Your breach of these Terms;</li>
              <li>Your negligent or willful misconduct;</li>
              <li>Your violation of any law or third-party rights.</li>
            </ul>
            <h3>8. Termination</h3>
            <ul>
              <li><b>By Us.</b> We may suspend or terminate your access to the Course at any time if you breach these Terms, for non-payment, or for conduct we deem harmful to other users or our business.</li>
              <li><b>By You.</b> You may discontinue using the Course at any time. All provisions of these Terms that by their nature should survive termination shall survive, including ownership provisions, disclaimer, limitation of liability, indemnity, and governing law.</li>
            </ul>
            <h3>9. Changes to Terms</h3>
            <p>We may update these Terms from time to time. When we do, we will revise the “Effective Date” at the top and notify you by email or site announcement. Continued access or use of the Course after the Effective Date constitutes acceptance of the revised Terms.</p>
            <h3>10. Governing Law & Dispute Resolution</h3>
            <ul>
              <li><b>Governing Law.</b> These Terms shall be governed by and construed in accordance with the laws of England & Wales, without regard to its conflict-of-law principles.</li>
              <li><b>Jurisdiction.</b> You agree that any dispute arising under these Terms shall be subject to the exclusive jurisdiction of the courts of England & Wales.</li>
              <li><b>Informal Resolution.</b> Before initiating legal proceedings, we both agree to attempt to resolve disputes informally by contacting the other party at the contact information below.</li>
            </ul>
            <h3>11. Severability & Waiver</h3>
            <p>If any provision of these Terms is held unenforceable, that provision will be struck and the remaining provisions will remain in full force. No waiver by either party of any breach shall be deemed a waiver of any subsequent breach.</p>
            <h3>12. Entire Agreement</h3>
            <p>These Terms, together with our Privacy Policy and Cookie Policy (each available via links in our site footer), constitute the entire agreement between you and Tilted Needle regarding the Course and supersede all prior or contemporaneous communications and proposals.</p>
            <h3>13. Contact Information</h3>
            <p>If you have any questions about these Terms, please contact us at:<br/>
            Email: <a href="mailto:support@viralagencymethod.com">support@viralagencymethod.com</a></p>
            <p className="terms-ack">By accessing or purchasing the Viral Agency Method course, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.</p>
          </div>
        </div>
      )}
      <button
        className="terms-bar-btn"
        style={{
          background: '#23272e',
          color: '#fff',
          fontSize: '0.95rem',
          fontWeight: 600,
          border: 'none',
          borderRadius: open ? '12px 12px 0 0' : '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
          padding: '8px 24px',
          margin: 8,
          cursor: 'pointer',
          minWidth: 180,
          pointerEvents: 'auto',
          zIndex: 1001,
          transition: 'border-radius 0.2s',
        }}
        aria-expanded={open}
        aria-controls="terms-dropdown-content"
        onClick={() => setOpen((v) => !v)}
      >
        Terms & Conditions
        <span style={{ marginLeft: 8, fontWeight: 700, fontSize: '1.2em', display: 'inline-block', transform: open ? 'rotate(45deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>+</span>
      </button>
    </div>
  );
} 